<template>
    <div>
        <base-modal ref="goToClaimModal" header-disable footer-disable>
            <template v-slot:body>
                <div class="samo samo-site">
                    <form class="login-form">
                        <div class="form-header">
                            <h1 class="login-modal_title">{{ $t('app.modals.go_to_claim.title') }}</h1>
                        </div>
                        <div class="form-group">
                            <label class="control-label samo-label" for="claim">{{
                                $t('app.modals.go_to_claim.claim_label') }}</label>
                            <input id="claim" class="samo-input form-control" :class="{ 'is-invalid': v$.claim.$error }"
                                v-model="claim" type="text">
                            <small class="error-message" v-if="v$.claim.$error">{{
                                $t(...getTranslateParams(v$.claim.$errors[0].$message)) }}</small>
                        </div>
                        <div class="form-group">
                            <label class="control-label samo-label" for="pasport">{{
                                $t('app.modals.go_to_claim.pasport_label') }}</label>
                            <input id="pasport" class="samo-input form-control"
                                :class="{ 'is-invalid': v$.pasport.$error }" v-model="pasport" type="text">
                            <small class="error-message" v-if="v$.pasport.$error">{{
                                $t(...getTranslateParams(v$.pasport.$errors[0].$message)) }}</small>
                        </div>
                        <div class="error-message my-2">
                            {{ error }}
                        </div>
                        <div class="form-group">
                            <a class="btn btn-primary text-white" @click="getLink">{{
                                $t('app.modals.go_to_claim.button_text') }}</a>
                        </div>
                        <div class="mt-4 p-3 demo-access" v-if="config?.main?.show_demo_access">
                            <div class="text-start" @click="setDemoAccess('90004534', '111111')">
                                <div class="mb-1"><strong>{{ $t('app.modals.go_to_claim.claim_label') }}: </strong>90004534</div>
                                <div><strong>{{ $t('app.modals.go_to_claim.pasport_label') }}: </strong>111111</div>
                            </div>
                        </div>
                    </form>
                </div>
            </template>
        </base-modal>
    </div>
</template>

<script>
import apiService from 'services/api.service.js'
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import BaseModal from 'components/ui/BaseModal.vue'
import { mapState } from "vuex"
import translateMixin from 'mixins/translate'

export default {
    name: "GoToClaimModal",
    components: { BaseModal },
    mixins: [translateMixin],
    setup() {
        return { v$: useVuelidate() }
    },
    data() {
        return {
            claim: '',
            pasport: '',
            error: null
        }
    },
    validations: {
        claim: { required },
        pasport: { required },
    },
    computed: {
        ...mapState({ 
            locale: state => state.locale,
            config: state => state.config,
         })
    },
    methods: {
        setDemoAccess(claim = '', pasport = ''){
            this.claim = claim;
            this.pasport = pasport;
        },
        open() {
            this.$refs.goToClaimModal.open();
        },
        getLink() {
            this.error = null;
            this.v$.$touch();
            if (!this.v$.$invalid) {
                const params = {
                    claim: this.claim,
                    pasport: this.pasport,
                };
                apiService.getFrApi({
                    url: 'status/getClaimKey',
                    method: 'get',
                    params: params,
                    locale: this.locale
                }).then(response => {
                    console.log(response.data);
                    if (response.data.success && response.data.data.length > 0) {
                        const routeData = this.$router.resolve({ name: 'status', params: { key: response.data.data } });
                        window.open(routeData.href, '_blank');
                        this.$refs.goToClaimModal.close();
                    } else {
                        this.error = this.$root.$t("app.modals.go_to_claim.error");
                    }

                })
            }
        }
    }
}
</script>
